/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var PhotoshopIcon = createIcon("PhotoshopIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: "#001E36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.871 34v-7.336h4.172c4.312 0 7.182-2.352 7.182-6.37 0-4.242-3.262-6.538-7.63-6.538h-7.182V34h3.458Zm4.088-10.066h-4.116v-7.49h4.018c2.366 0 4.13 1.33 4.13 3.654 0 2.282-1.666 3.836-4.032 3.836Zm15.05 10.346c3.57 0 5.852-1.638 5.852-4.438 0-1.358-.7-3.318-3.668-4.06l-2.604-.63c-1.582-.336-2.352-.798-2.352-1.68 0-1.26 1.134-1.876 2.744-1.876 1.554 0 2.562.742 2.772 1.988h2.898c-.07-2.786-2.268-4.34-5.642-4.34-3.822 0-5.824 1.89-5.81 4.466.014 2.282 1.61 3.444 4.074 3.99l2.744.63c1.316.28 1.876.798 1.876 1.708 0 1.246-1.162 1.834-2.898 1.834-1.456 0-2.898-.658-3.276-2.268h-2.996c.476 3.276 3.262 4.676 6.286 4.676Z",
    fill: "#31A8FF"
  }));
}, {
  "i18nKey": "svg.PhotoshopIcon"
});